import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { formatUpdatedAgo, getCookie } from '../../home/app_util';

export default class CollectionDetail extends Component {
  static propTypes = {
    collection: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  render() {
    let token = getCookie('token');
    if (!token) {
      token = '';
    }
    const { collection, projectId, redirectUrl, version } = this.props;
    const { collectionTitle, collectionName, uuid, updatedAt } = collection;
    const updatedAgo = formatUpdatedAgo(updatedAt);
    return (
      <div className="d-flex justify-content-around align-content-center">
        <a
          href={`${redirectUrl}collections/${version}/v/${projectId}/items/${uuid}/name/${collectionName}?token=${token}`}
          className={`list-group-item list-group-item-action align-items-center`}
          style={{ cursor: 'pointer', width: '90%', float: 'left' }}
          onClick={() => {
            Mixpanel.track('Clicked on- Collection items details on builder', {
              collectionName,
              uuid,
            });
          }}
        >
          <i className="gjs-caret-icon wb webconnect-database"></i>&nbsp;{collectionTitle}
          <br />
          <small className="text-muted ml-3">{`Updated ${updatedAgo}`}</small>
        </a>
        <a
          className="pages-list-left-menu my-auto"
          href={`${redirectUrl}collections/${version}/v/${projectId}/edit/${uuid}?token=${token}`}
          onClick={() => {
            Mixpanel.track('Clicked on- Collection config icon on builder', {
              collectionName,
              uuid,
            });
          }}
        >
          <span
            className="badge badge-theme"
            style={{ padding: 8, cursor: 'pointer', float: 'right' }}
          >
            <i className="gjs-caret-icon wb webconnect-cog" size={'md'}></i>
          </span>
        </a>
      </div>
    );
  }
}
